import React, { type HTMLAttributes } from 'react';

import {
  Container,
  Downloads,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphDownloads as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphDowloadsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphDownloads: React.FC<ParagraphDowloadsProps> = ({
  id,
  entity,
}) => {
  const paragraphDownloads = entity.toJS();

  const title = paragraphDownloads.field_title[0]?.value;
  const body = paragraphDownloads.field_body[0]?.processed;
  const downloads = paragraphDownloads.field_downloads;

  const downloadItems = downloads.map((download) => {
    const file = 'field_media_document' in download.entity
      ? download.entity.field_media_document[0]
      : download.entity.field_media_file[0];

    return (
      {
        source: file.source,
        title: download.title,
        caption: download.entity.field_caption?.[0]?.value,
        filename: file.filename,
        filesize: download.file_size,
        mime: download.mime_type,
      }
    );
  });

  return (
    <div id={id} className="Paragraph ParagraphDownloads">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Downloads
              title={title}
              text={body}
              downloads={downloadItems}
              materialIconName="file_download"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphDownloads;
